module.exports = __webpack_public_path__ + "static/img/085_TO8_1738_og.862b7e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/085_TO8_1738_og.jpg
// module id = JDO+
// module chunks = 0